/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { startTransition, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button, OverlayTrigger, Popover, Badge, Card } from "react-bootstrap";
import { QuestionCircle } from "react-bootstrap-icons";
import PropTypes from "prop-types";

import LoadingWrapper from "../../widgets/LoadingWrapper";
import queryString from "query-string";

function BillingInfo(props) {
  const formValue = useSelector((state) => state.basic);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [planType, setPlanType] = useState("annual");
  const initializeData = () => {
    dispatch({ type: "GET_SUBSCRIPTION" });
    const couponSuggestion = props.location
      ? queryString.parse(props.location.search).couponSuggestion
      : "";
    if (couponSuggestion) {
      dispatch({ type: "CHECK_PROMO_CODE", promoCode: couponSuggestion });
    }
    !(function () {
      if (window.barecancel && window.barecancel.created)
        window.console && console.error && console.error("Barecancel snippet included twice.");
      else {
        window.barecancel = { created: !0 };
        var a = document.createElement("script");
        ((a.src = "https://baremetrics-barecancel.baremetrics.com/js/application.js"),
          (a.async = !0));
        var b = document.getElementsByTagName("script")[0];
        (b.parentNode.insertBefore(a, b),
          (window.barecancel.params = {
            access_token_id: "505e2703-648c-43b3-8491-e02c49d26203", // Your Cancellation API public key
            customer_oid: formValue.localUser.stripe_customer_id, // The provider id of this customer. For example, the Stripe Customer ID
            callback_send: function () {
              dispatch({ type: "CANCEL_PLAN" });
            },
            callback_error: function (error) {
              console.error(error);
            },
          }));
      }
    })();
  };
  useEffect(initializeData, []);

  /**
   * Construct the checkout link, based on the current selected plan, interval, AI plan,
   * and any ala carte options selected.
   * @param {string} selectedPlan The current selected ha plan
   * @param {string} selectedPlanInterval The current selected ha plan interval
   * @returns {string} The constructed link to the checkout page
   */
  const constructCheckoutLink = (selectedPlan, selectedPlanInterval) => {
    const checkoutLink = "/checkout";
    const searchParams = new URLSearchParams();
    searchParams.append("plan", selectedPlan);
    searchParams.append("interval", selectedPlanInterval === "yearly" ? "annual" : "monthly");
    return `${checkoutLink}?${searchParams.toString()}`;
  };

  const goToCheckout = (selectedPlan, selectedPlanInterval) => {
    const checkoutLink = constructCheckoutLink(selectedPlan, selectedPlanInterval);
    startTransition(() => navigate(checkoutLink));
  };

  return (
    <React.Fragment>
      {!formValue.subscription.plan ||
      formValue.subscription.plan === "starter" ||
      formValue.subscription.plan === "pro" ||
      formValue.subscription.plan === "powerhouse" ||
      formValue.subscription.plan === "starter-annual" ||
      formValue.subscription.plan === "pro-annual" ||
      formValue.subscription.plan === "powerhouse-annual" ||
      formValue.subscription.plan.match(/founder/) ||
      formValue.subscription.plan === "trial" ? (
        <div className="billing-background">
          <LoadingWrapper loadingKey="get-subscription">
            <Container fluid>
              <Row className="flex-row">
                <Col className="d-flex justify-content-center mx-auto my-3">
                  <Button
                    className="mx-2"
                    variant={planType === "annual" ? "primary" : "light"}
                    onClick={() => setPlanType("annual")}
                  >
                    Annual Billing
                  </Button>
                  <Button
                    className="mx-2"
                    variant={planType === "monthly" ? "primary" : "light"}
                    onClick={() => setPlanType("monthly")}
                  >
                    Monthly Billing
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Row
                    className="billing-mediabreak-card mt-3 justify-content-center"
                    xs={1}
                    sm={1}
                    md={3}
                    lg={3}
                    xl={3}
                  >
                    <Col
                      className="mb-5 card billing-card box-shadow card-hover"
                      style={{ height: "fit-content" }}
                      xl={3}
                    >
                      <Card.Header>
                        <h3 className="my-3" style={{ color: "#2e20b1" }}>
                          Starter
                        </h3>
                      </Card.Header>

                      <Card.Body className="pt-0">
                        <Row className="list-unstyled mb-0 flex-column">
                          <Col>
                            <li className="d-flex border-top py-2">
                              <span>
                                &#10004; <strong>1</strong> Private Feed &nbsp;
                              </span>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Popover>
                                    <Popover.Content>
                                      Private feeds aren&apos;t searchable in directories like
                                      Spotify or Apple. They&apos;re unlisted. Only those who
                                      you&apos;ve given access to can listen to this content in
                                      their podcast app.
                                    </Popover.Content>
                                  </Popover>
                                }
                              >
                                <span className="d-flex align-items-center">
                                  <QuestionCircle />
                                </span>
                              </OverlayTrigger>
                            </li>
                            <li className="d-flex border-top py-2">
                              <span>
                                &#10004; <strong>1</strong> Public Feed &nbsp;
                              </span>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Popover>
                                    <Popover.Content>
                                      For launching your own public podcast so you show up in public
                                      directories like Apple Podcasts, Spotify, etc.
                                    </Popover.Content>
                                  </Popover>
                                }
                              >
                                <span className="d-flex align-items-center">
                                  <QuestionCircle />
                                </span>
                              </OverlayTrigger>
                            </li>
                            <li className="border-top py-2">
                              &#10004; <strong>Unlimited</strong> Episodes
                            </li>
                            <li className="border-top py-2">
                              &#10004; <strong>Unlimited</strong> Listeners
                            </li>
                            <li className="border-top py-2">
                              &#10004; <strong>Automatic</strong> video to audio conversion
                            </li>
                            <li className="d-flex border-top py-2">
                              <span>
                                &#10004; <strong>Zapier Steps</strong> &nbsp;
                              </span>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Popover>
                                    <Popover.Content>
                                      Add/remove listeners automatically with Zapier.
                                    </Popover.Content>
                                  </Popover>
                                }
                              >
                                <span className="d-flex align-items-center">
                                  <QuestionCircle />
                                </span>
                              </OverlayTrigger>
                            </li>
                            <li className="d-flex border-top py-2">
                              <span>&#10004; Instant Release Feeds &nbsp;</span>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Popover>
                                    <Popover.Content>
                                      All audio files are released immediately. Useful for things
                                      you want your customers to binge. Examples: Courses,
                                      Membership site core content, Lead magnets.
                                    </Popover.Content>
                                  </Popover>
                                }
                              >
                                <span className="d-flex align-items-center">
                                  <QuestionCircle />
                                </span>
                              </OverlayTrigger>
                            </li>
                            <li className="d-flex border-top py-2">
                              <span>&#10004; Date-Based Feeds &nbsp;</span>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Popover>
                                    <Popover.Content>
                                      Audio files are released by the calendar date you determine.
                                      This is good for products that are hosted as part of a live
                                      experience. Examples: Summits, Q+A Calls, Events.
                                    </Popover.Content>
                                  </Popover>
                                }
                              >
                                <span className="d-flex align-items-center">
                                  <QuestionCircle />
                                </span>
                              </OverlayTrigger>
                            </li>
                            <li className="border-top py-2">&#10004; Embeddable Player</li>
                            <li className="border-top py-2">&#10004; One-Click Listener Access</li>
                            <li className="border-top border-bottom py-2">
                              &#10004; Listener Management
                            </li>
                          </Col>
                          <Col className="pt-3 text-center">
                            {planType === "annual" ? (
                              <>
                                <h1>$14</h1>
                                <small className="text-muted">PER MONTH, BILLED ANNUALLY</small>
                              </>
                            ) : (
                              <>
                                <h1>$17</h1>
                                <small className="text-muted">PER MONTH</small>
                              </>
                            )}
                          </Col>
                          <Col>
                            <br />
                            <Button
                              className="btn btn-lg btn-block btn-primary w-100 "
                              style={{ backgroundColor: "#2e20ba" }}
                              onClick={
                                planType === "monthly"
                                  ? () => goToCheckout("starter", "monthly")
                                  : () => goToCheckout("starter", "yearly")
                              }
                            >
                              <span className="ml-1">Get Started</span>
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Col>

                    <Col
                      className="mb-5 mx-3 card billing-card box-shadow card-hover"
                      style={{ height: "fit-content" }}
                      xl={3}
                    >
                      <Card.Header>
                        <Badge variant="dark">MOST POPULAR</Badge>
                        <h3 className="mt-3" style={{ color: "#69FECF" }}>
                          Pro
                        </h3>
                      </Card.Header>

                      <Card.Body className="pt-0 ">
                        <Row className="list-unstyled mb-0 flex-column">
                          <Col className="px-2">
                            <li className="border-top py-2">
                              &#10004; <strong>3</strong> Private Feeds
                            </li>
                            <li className="border-top py-2">
                              &#10004; <strong>1</strong> Public Feed
                            </li>
                            <li className="border-top py-2">
                              &#10004; <strong>All Starter Features</strong>
                            </li>
                            <li className="d-flex border-top py-2">
                              <span>&#10004; Dripped Feeds &nbsp;</span>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Popover>
                                    <Popover.Content>
                                      Audio files are released based on a number of days after the
                                      previous episode was released. This is great for products
                                      where your customers go through at the pace at which they sign
                                      up. Example: Self-paced courses or Challenges.
                                    </Popover.Content>
                                  </Popover>
                                }
                              >
                                <span className="d-flex align-items-center">
                                  <QuestionCircle />
                                </span>
                              </OverlayTrigger>
                            </li>
                            <li className="d-flex border-top py-2">
                              <span>
                                &#10004; <strong>Advanced</strong> Date-Based Feeds &nbsp;
                              </span>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Popover>
                                    <Popover.Content>
                                      Restrict episodes before listener&apos;s start date.
                                    </Popover.Content>
                                  </Popover>
                                }
                              >
                                <span
                                  className="d-flex align-items-center"
                                  style={{ maxHeight: "41px" }}
                                >
                                  <QuestionCircle />
                                </span>
                              </OverlayTrigger>
                            </li>
                            <li className="border-top border-bottom py-2">
                              &#10004; Expiring Feeds
                            </li>
                          </Col>
                          <Col className="pt-3 text-center">
                            {planType === "annual" ? (
                              <>
                                <h1>$39</h1>
                                <small className="text-muted">PER MONTH, BILLED ANNUALLY</small>
                              </>
                            ) : (
                              <>
                                <h1>$47</h1>
                                <small className="text-muted">PER MONTH</small>
                              </>
                            )}
                          </Col>
                          <Col>
                            <br />
                            <Button
                              className="btn btn-lg btn-block btn-primary w-100 "
                              style={{ backgroundColor: "#2e20ba" }}
                              onClick={
                                planType === "monthly"
                                  ? () => goToCheckout("pro", "monthly")
                                  : () => goToCheckout("pro", "yearly")
                              }
                            >
                              <span className="ml-1">Get Started</span>
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Col>

                    <Col
                      className="mb-5 card billing-card box-shadow card-hover"
                      style={{ height: "fit-content" }}
                      xs={3}
                      xl={3}
                    >
                      <Card.Header>
                        <h3 className="my-3" style={{ color: "#FFD503" }}>
                          Powerhouse
                        </h3>
                      </Card.Header>

                      <Card.Body className="pt-0">
                        <Row className="list-unstyled mb-0 flex-column">
                          <Col>
                            <li className="border-top py-2">
                              &#10004; <strong>Unlimited</strong> Private Feeds
                            </li>
                            <li className="border-top py-2">
                              &#10004; <strong>2</strong> Public Feeds &nbsp;
                            </li>
                            <li className="border-top py-2">
                              &#10004; <strong>Unlimited</strong> Transcripts
                            </li>
                            <li className="border-top py-2">
                              &#10004; <strong>All Pro &#x2b; Starter Features</strong>
                            </li>
                            <li className="d-flex border-top py-2">
                              <span>
                                &#10004; <strong>Dynamic</strong> Content &nbsp;
                              </span>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Popover>
                                    <Popover.Content>
                                      Pre- and Post-roll, up to 3 slots. Can be scheduled, and/or
                                      limited to certain listener tags.
                                    </Popover.Content>
                                  </Popover>
                                }
                              >
                                <span className="d-flex align-items-center">
                                  <QuestionCircle />
                                </span>
                              </OverlayTrigger>
                            </li>
                            <li className="d-flex border-top py-2">
                              <span>
                                &#10004; Automated <strong>Actions</strong> &nbsp;
                              </span>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Popover>
                                    <Popover.Content>
                                      Take action when listeners engage with your content.
                                    </Popover.Content>
                                  </Popover>
                                }
                              >
                                <span className="d-flex align-items-center">
                                  <QuestionCircle />
                                </span>
                              </OverlayTrigger>
                            </li>
                            <li className="d-flex border-top py-2">
                              <span>
                                &#10004; <strong>Advanced</strong> Drip Feeds &nbsp;
                              </span>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Popover>
                                    <Popover.Content>
                                      Schedule &quot;undripping&quot; of a dripped episode.
                                    </Popover.Content>
                                  </Popover>
                                }
                              >
                                <span className="d-flex align-items-center">
                                  <QuestionCircle />
                                </span>
                              </OverlayTrigger>
                            </li>
                            <li className="border-top py-2">
                              &#10004; Custom branding{" "}
                              <span className="text-danger font-weight-bold">colors</span>
                            </li>
                            <li className="d-flex border-top py-2">
                              <span>
                                &#10004; <strong>Zapier Triggers</strong> &nbsp;
                              </span>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Popover>
                                    <Popover.Content>
                                      All plans can add/remove listeners with Zapier. On Powerhouse,
                                      triggers allow for more advanced automations that start with
                                      &quot;When this happens in Hello Audio...&quot;
                                    </Popover.Content>
                                  </Popover>
                                }
                              >
                                <span className="d-flex align-items-center">
                                  <QuestionCircle />
                                </span>
                              </OverlayTrigger>
                            </li>
                            <li className="border-top border-bottom py-2">
                              &#10004; Premium Support
                            </li>
                          </Col>
                          <Col className="pt-3 text-center">
                            {planType === "annual" ? (
                              <>
                                <h1>$81</h1>
                                <small className="text-muted">PER MONTH, BILLED ANNUALLY</small>
                              </>
                            ) : (
                              <>
                                <h1>$97</h1>
                                <small className="text-muted">PER MONTH</small>
                              </>
                            )}
                          </Col>
                          <Col>
                            <br />
                            <Button
                              className="btn btn-lg btn-block btn-primary w-100"
                              style={{ backgroundColor: "#2e20ba" }}
                              onClick={
                                planType === "monthly"
                                  ? () => goToCheckout("powerhouse", "monthly")
                                  : () => goToCheckout("powerhouse", "yearly")
                              }
                            >
                              <span className="ml-1">Get Started</span>
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </LoadingWrapper>
        </div>
      ) : (
        <div className="billing-background">
          <LoadingWrapper loadingKey="get-subscription">
            <Container>
              <Row className="text my-4 justify-content-center flex-column text-center">
                <div>You are on a lifetime plan.</div>
                <div>This does not require billing information.</div>
                <div>Please contact us if you would like help with your plan.</div>
              </Row>
            </Container>
          </LoadingWrapper>
        </div>
      )}
    </React.Fragment>
  );
}

BillingInfo.propTypes = {
  location: PropTypes.object,
};

export default BillingInfo;
